/**
 * Data layer for `payment-hold-threshold-minimum-balance-before-rele`. Thin typed fetch wrappers over /api/v1/payment-hold-threshold-minimum-balance-before-rele.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface PaymentHoldThresholdMinimumBalanceBeforeReleRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListPaymentHoldThresholdMinimumBalanceBeforeReleResponse {
	count: number;
	items: PaymentHoldThresholdMinimumBalanceBeforeReleRow[];
}

export interface CreatePaymentHoldThresholdMinimumBalanceBeforeReleBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/payment-hold-threshold-minimum-balance-before-rele";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListPaymentHoldThresholdMinimumBalanceBeforeReleResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListPaymentHoldThresholdMinimumBalanceBeforeReleResponse>(res);
}

export async function create(body: CreatePaymentHoldThresholdMinimumBalanceBeforeReleBody): Promise<PaymentHoldThresholdMinimumBalanceBeforeReleRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<PaymentHoldThresholdMinimumBalanceBeforeReleRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const paymentHoldThresholdMinimumBalanceBeforeReleQueryKeys = {
	all: ["payment-hold-threshold-minimum-balance-before-rele"] as const,
	list: () => [...paymentHoldThresholdMinimumBalanceBeforeReleQueryKeys.all] as const,
	detail: (id: string) => [...paymentHoldThresholdMinimumBalanceBeforeReleQueryKeys.all, id] as const,
};
